import { render } from "./TopStatisticChart.vue?vue&type=template&id=12bd472c&scoped=true&ts=true"
import script from "./TopStatisticChart.vue?vue&type=script&lang=ts"
export * from "./TopStatisticChart.vue?vue&type=script&lang=ts"

import "./TopStatisticChart.vue?vue&type=style&index=0&id=12bd472c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bd472c"]])

export default __exports__